import { render } from "./MainPanel.vue?vue&type=template&id=74fcde19&scoped=true"
const script = {}

import "./MainPanel.vue?vue&type=style&index=0&id=74fcde19&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fcde19"]])

export default __exports__